import React from "react";
import styles from "./LanguagePills.module.scss";
import { Chip } from "@mui/material";
import CheckedCircleIcon from "../icon-components/CheckedCircleIcon";

interface Language {
  languageId: number;
  languageName: string;
  languageCode: string;
}

interface LanguagePillsProps {
  activeLanguages: Language[];
  selectedLanguageIds: number[];
}

const LanguagePills: React.FC<LanguagePillsProps> = ({
  activeLanguages,
  selectedLanguageIds,
}) => {
  return (
    <div className={styles.container}>
      {activeLanguages.map((language) => {
        const isSelected = selectedLanguageIds.includes(language.languageId);
        return (
          <Chip
            data-testid="language-pill"
            key={language.languageId}
            label={
              <span className={styles.label}>{language.languageName}</span>
            }
            icon={
              <CheckedCircleIcon
                width={16}
                height={16}
                variant={isSelected ? "completed" : "notStarted"}
              />
            }
            className={styles.pill}
          />
        );
      })}
    </div>
  );
};

export default LanguagePills;
